<template>
    <main id="app">
        <Header />

        <transition :name="transitionName">
            <router-view/>
        </transition>

        <Footer />
    </main>
</template>

<script>
    import Header from './components/Header.vue';
    import Footer from './components/Footer.vue';

    export default {
        name: 'App',

        data() {
            return {
                transitionName: 'slide',
            };
        },

        components: {
            Header,
            Footer,
        },
    };
</script>
